import { render, staticRenderFns } from "./UserSubscriptions.vue?vue&type=template&id=2f66e10f&scoped=true&"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js&"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./UserSubscriptions.vue?vue&type=style&index=0&id=2f66e10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f66e10f",
  null
  
)

export default component.exports